export default __webpack_public_path__ + "static/media/CommentBox.71ec39d2.svg";